/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Key_SupadataInputs */

const en_ai_key_supadata = /** @type {(inputs: Ai_Key_SupadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supadata API key`)
};

const de_ai_key_supadata = /** @type {(inputs: Ai_Key_SupadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supadata-API-Schlüssel`)
};

/**
* | output |
* | --- |
* | "Supadata API key" |
*
* @param {Ai_Key_SupadataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_key_supadata = /** @type {((inputs?: Ai_Key_SupadataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Key_SupadataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_key_supadata(inputs)
	return en_ai_key_supadata(inputs)
});